import VxeTable from './src/VxeTable.vue';
import { Column, Colgroup } from 'vxe-table'
import Vue from 'vue'

Vue.component(VxeTable['options'].name, VxeTable);
Vue.use(Column).use(Colgroup)